export default __webpack_public_path__ + "static/media/wash-and-fold.41140eca.jpg";